module.exports = __webpack_public_path__ + "img/00007.420c3520.webp";